var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.37 390.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.34,63.18c.06,5.51-2.09,7.55-7.57,7.58-14.42,.09-28.88,0-43.24,1.1-14.14,1.08-22.03,9.1-22.75,23.29-.83,16.26-.25,32.6-.5,48.89-.09,5.61,3.3,5.71,7.35,5.69,17.91-.06,35.81-.05,53.72-.01,10.18,.02,10.17,.15,8.81,10.57-2.42,18.53-5.01,37.04-6.92,55.62-.79,7.65-4.32,9.73-11.44,9.54-14.15-.38-28.34,.19-42.49-.23-7.03-.21-9.16,2.21-9.13,9.23,.25,50.51,.13,101.03,.11,151.54,0,1.6-.24,3.19-.36,4.79H62.33c.02-51.85-.09-103.7,.21-155.55,.05-7.76-2.48-10.27-10.12-10.02-14.42,.48-28.86-.05-43.29,.19C2.72,225.5-.07,223.18,0,216.56c.22-19.51,.17-39.02,0-58.53-.05-6.03,2.03-8.58,8.43-8.43,15.23,.36,30.47-.17,45.7,.24,6.36,.17,8.35-1.98,8.36-8.22,.03-18.96-.42-38.01,1.17-56.86,2.57-30.5,14.56-56.24,42.48-72.09C122.58,3.34,140.62-.21,159.29,0c16.02,.19,32.01,1.49,48.03,2.06,5.61,.2,8.14,2.24,8.06,8.19-.25,17.64-.21,35.28-.03,52.92Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.89b5c82450beb17bc91a01e349cbf6ff.svg";
export { ForwardRef as ReactComponent };